module.exports = __webpack_public_path__ + "img/onboarding1.8bafda0e.png";